module.exports = __webpack_public_path__ + "imgesssyaa/svg/Calendar.fb31aafb.svg";